import { getCellEventObject } from '@/common/utils/gnb.fp'
import fp from 'lodash/fp'
import _ from 'lodash'
import constant from '@/common/resources/constant'
import { MENU, STORAGE_ROUTER_HISTORY, STORAGE_TRANSACTION_KEY } from '@/common/resources/const'
import { parseUrl } from 'query-string'

export const getCurrentUrl = () => location.href.replace(location.origin, '')
export const getTransactionKey = () => sessionStorage.getItem(STORAGE_TRANSACTION_KEY) || ''
export const getSecondLastPage = () => JSON.parse(sessionStorage.getItem(STORAGE_ROUTER_HISTORY))[1] || ''

export const getGnCode = name => {
  const { HOME, CATEGORY, MY, LIVE } = MENU
  let gnCode = name
  switch (name) {
    case HOME :
      gnCode = 51
      break
    case CATEGORY :
      gnCode = 52
      break
    case MY :
      gnCode = 53
      break
    case LIVE :
      gnCode = 54
      break
  }
  return `GN${gnCode}`
}

/**
 * contentType 을 받아 serviceType 으로 치환한다. (ex. movieppv -> movieplus)
 * @param type
 * @returns {string}
 */
export const convertServiceType = (type) => {
  let serviceType = type
  switch (type) {
    case 'vod' :
      serviceType = 'episode'
      break
    case 'moviesvod' :
      serviceType = 'movie'
      break
    case 'movieppv' :
      serviceType = 'movieplus'
      break
    case 'theme_title' :
      serviceType = 'theme'
      break
    case 'vodbaseball' :
      serviceType = 'baseball'
      break
  }
  return serviceType
}

/**
 * cellInfo 를 받아 content_type 을 참조하여 serviceType 을 반환한다.
 * @param cellInfo
 * @returns {string}
 */
export const getServiceTypeFromCellInfo = (cellInfo = {}) => {
  const rawContentType = cellInfo?.content_type || getEventAttrType(cellInfo, 'contenttype')
  const contentType = (rawContentType === 'movie')
    ? `movie${_.get(cellInfo, 'bottom_taglist.0') === 'won' ? 'ppv' : 'svod' }`
    : rawContentType
  return convertServiceType(contentType)
}

/**
 * url 을 받아 /list/ 뒤에 있는 uiCode 를 반환한다.
 * @param url
 * @returns {string|*}
 */
export const getContentsUiCode = url => {
  let contentCode = parseUrl(url).url.match(/(\d+)$/gi)
  if (contentCode.length >= 1) {
    contentCode = contentCode.join('')
    return contentCode.match(/^\d/gi) ? `EN${contentCode}` : contentCode
  }
}

/**
 * cellItemInfo 를 받아 attribute 의 값을 반환한다.
 * @param cellItemInfo
 * @param attribute
 * @returns {*|string}
 */
export const getEventAttrType = (cellItemInfo, attribute) => {
  const eventListKey = cellItemInfo?.event_list.filter(item => item.type === 'on-display' || 'on-click')[0]
  const attrTypeInEvent = eventListKey.bodylist.filter(bodyParam => bodyParam.indexOf(`${attribute}:`) > -1)
  const attrType = attrTypeInEvent[0]?.split(':')[1] ?? ''
  return attrType
}

/**
 * cellInfo 를 받아 query 와 url 을 반환한다.
 * @param cellInfo
 * @returns {{query: (any|string), url: string}}
 */
export const getUrlFromCellInfo = (cellInfo) => {
  const { onNavigation } = fp.flow(fp.get('event_list'), getCellEventObject)(cellInfo)
  const urlReplaceList = [
    constant.URL_DOMAIN,
    constant.URL_PROTOCOL_DEEP_LINK,
    'www.wavve.com',
    'http://',
    'https://'
  ]
  const replacedURL = urlReplaceList.reduce((acc, currentURL) => {
    return acc.replace(currentURL, '')
  }, _.get(onNavigation, 'url', ''))
  const { query } = parseUrl(replacedURL)
  const url = replacedURL.replace('/index.html', '').replace('.html', '')
  return { url, query }
}
